'use strict';

var helper = require('../helper');

module.exports = {
    pushScalaPayAndKlarnaModalsInteraction (payment, page) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '63',
            'eventname': 'payment_info',
            'payment_method': payment
        };

        helper.log('Pushing ScalaPay modal interaction', true);
        helper.push(pushObject);
    }
};
